import  React, { useState } from 'react'; 
import { Button, Modal, Input } from 'antd';  
import useAIUpdatePrompt from '../../gql/hooks/useAIUpdatePrompt';

const AISavePrompt = ( { promptId, disabled = false } ) => { 
    const [ modalOpen, setModalOpen ] = useState( false );
    const [ saveName, setSaveName ] = useState( '' );
    const [ disableSaveButton, setDisableSaveButton ] = useState( true );
    const { updatePrompt, isSavingPrompt: isSaving } = useAIUpdatePrompt();
    
    /*************************************
     *  ANCHOR Save handling
     *************************************/

    const savePrompt = async () => {
        const vars = {
            promptId: promptId,
            label: saveName,
            isSaved: true,
        };

        const response = await updatePrompt( vars );
        const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
        
        if ( success ) {
            setModalOpen( false );
            setSaveName( '' );
        } else {
            setModalOpen( false );
            setSaveName( '' );
        }
    };

    /*************************************
     *  ANCHOR Event Handlers
     *************************************/

    const handleSaveClick = () => {
        savePrompt();
    };

    const handleCancelClick = () => {
        setModalOpen( false );
    };

    const handleOpenClick = () => {
        setSaveName( '' );
        setModalOpen( !modalOpen );
    };

    const handleInputChange = ( e ) => {
        const value = e.target.value.trim();
        setSaveName( value );
        setDisableSaveButton( value.length < 1 );
    };

    /*************************************
     *  ANCHOR Render
     *************************************/
    
    return ( 
        <div>
            <Button
                type="primary" 
                disabled={ disabled }
                onClick= { handleOpenClick  }
            >
                Save Prompt
            </Button>

            <Modal
                title="Save Prompt"
                open={ modalOpen }
                onOk={ handleSaveClick }
                confirmLoading={ isSaving }
                onCancel={ handleCancelClick }
                okText="Save"
                destroyOnClose={ true }
                okButtonProps={ {
                    disabled: disableSaveButton
                } }
                cancelButtonProps={ {
                    disabled: isSaving,
                } }
            >
                <p>Save prompt with name:</p>
                <Input 
                    onChange={ handleInputChange }
                />
            </Modal>
        </div>
    );
};

export default AISavePrompt;
